class FeaturedProductsSlider extends HTMLElement {
  connectedCallback() {
    if (typeof Splide === 'undefined') {
      document.querySelector('script[src*="splide"]')?.addEventListener('load', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    const perPage = parseInt(this.dataset.perPage, 10) || 4;

    this.splide = new Splide(this, {
      type: 'loop',
      perPage,
      perMove: 1,
      gap: '24px',
      arrows: true,
      pagination: false,
      speed: 500,
      easing: 'ease',
      breakpoints: {
        1023: { perPage: Math.min(perPage, 3) },
        749:  { perPage: 2, gap: '12px' },
        479:  { perPage: 2, gap: '10px'  },
      },
    });

    this.splide.mount();
  }

  disconnectedCallback() {
    this.splide?.destroy();
  }
}

customElements.define('featured-products-slider', FeaturedProductsSlider);
